import axios from 'axios';

import { UnauthorizedType } from '../types/UnauthorizedType';
import { MessageResultType } from '../types/MessageResultType';
import headers from '../headers.json';

type SuccessType = {
  success: boolean;
  message: string;
  data: MessageResultType;
};

type PromiseType =
  | { data: SuccessType; success: boolean }
  | { data: UnauthorizedType; success: boolean }
  | { data: null; success: boolean };

type DataType = {
  examples: [string, string][];
  language: string;
  translations: {
    [key: string]: [string, string][];
  };
};

const POST_TRANSLATIONS = async (data: DataType): Promise<PromiseType> => {
  try {
    const serverUrl = process.env.REACT_APP_SERVER_URL_BACKEND_API;
    if (!serverUrl) throw Error('Backend-URL not defined.');

    const url = `${serverUrl}/translations/update/`;

    const response = await axios.post<SuccessType | UnauthorizedType>(url, data, {
      headers: {
        ...headers,
      },
      withCredentials: true,
    });

    if (response.data.success) {
      return { success: true, data: response.data };
    }

    return { success: false, data: response.data };
  } catch (error) {
    console.error(error);

    return { success: false, data: null };
  }
};

export default POST_TRANSLATIONS;
